import WordCloudDisplay from './WordCloudDisplay';
import BarChartDisplay from './BarChartDisplay';
import ResponseListDisplay from './ResponseListDisplay';
import ScaleDisplay from './ScaleDisplay';
import ContentDisplay from './ContentDisplay';

const DISPLAY_MAP = {
  wordcloud: WordCloudDisplay,
  multiplechoice: BarChartDisplay,
  openended: ResponseListDisplay,
  scale: ScaleDisplay,
  content: ContentDisplay,
};

export default function SlideRenderer({ slide, responses: rawResponses, participantCount }) {
  // Convert responses from Firestore object { participantId: { value, submittedAt } }
  // to array format [{ value, submittedAt, participantId }] for display components
  const responses = Array.isArray(rawResponses)
    ? rawResponses
    : rawResponses && typeof rawResponses === 'object'
      ? Object.entries(rawResponses).map(([pid, data]) => ({ ...data, participantId: pid }))
      : [];
  if (!slide) {
    return (
      <div className="flex items-center justify-center h-full text-blue-300 text-2xl">
        Ingen slide vald
      </div>
    );
  }

  const DisplayComponent = DISPLAY_MAP[slide.type];

  if (!DisplayComponent) {
    return (
      <div className="flex items-center justify-center h-full text-red-400 text-xl">
        Ukjend slide-type: {slide.type}
      </div>
    );
  }

  const isContentSlide = slide.type === 'content';

  return (
    <div className="flex flex-col items-center w-full h-full px-8 py-6">
      {slide.title && (
        <h1 className="text-4xl md:text-5xl font-bold text-white text-center mb-2 leading-tight">
          {slide.title}
        </h1>
      )}
      {slide.description && (
        <p className="text-lg md:text-xl text-blue-200 text-center mb-6 max-w-3xl">
          {slide.description}
        </p>
      )}

      <div className="flex-1 w-full flex items-center justify-center">
        {isContentSlide ? (
          <ContentDisplay slide={slide} />
        ) : (
          <DisplayComponent
            slide={slide}
            responses={responses || []}
            participantCount={participantCount || 0}
          />
        )}
      </div>
    </div>
  );
}
